module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/oEiDrx/image/FC-9781035816538.jpg?1708992404728",
      "alt": "This image is the cover for the book Six Tidies Up"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Six Tidies Up\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Join Fiona, Angus and their animal companions – Six the six-toed cat and Squeaky the tiny mouse – on a wild adventure of fun and chaos in their cosy home on Brydon Street. Follow the delightful tale of pillow wars, leafy messes, and unexpected help from a furry friend. Will they ever overcome the mess they’ve made? Find out in this heartwarming story of family, fun and a touch of furry magic. Also includes nine pages of activities.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Adam Green, Alexandria Skaltsinous\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Raised in Surrey, England Adam’s early career in banking in no way prepared him for a later career as a US-based actor and award-winning film producer. From Los Angeles and back to London, he founded kids’ tech startup Cleverworld, creating and producing fun interactive early educational apps, before turning his attentions to his daughter’s childhood cat Six. When not travelling and dreaming up new adventures for Six, he can be found swimming and enjoying sports.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0